var _path, _path2, _polygon, _polygon2, _path3, _path4, _polygon3, _polygon4, _g, _defs, _clipPath, _rect, _g2, _defs2, _clipPath2, _rect2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "251px",
    height: "84px",
    viewBox: "0 0 251 84",
    enableBackground: "new 0 0 251 84",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.496,34.454h-14.867v3.131h6.684v6.95H98.678V27.506h21.818V34.454z M120.496,54.95H98.678v-6.946 h21.818V54.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.002,54.95h-23.707l11.85-29.136L145.002,54.95z M135.686,48.006l-2.541-6.228l-2.635,6.228H135.686z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "160.902,34.275 153.947,34.275 153.947,54.95 147,54.95 147,34.275 140.732,34.275 140.732,27.342  160.902,27.342  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "179.018,54.95 162.674,54.95 162.674,27.342 169.621,27.342 169.621,48.004 179.018,48.004  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#844C9E",
    d: "M119.496,34.454h-14.867v3.131h6.684v6.95H97.678V27.506h21.818V34.454z M119.496,54.95H97.678v-6.946 h21.818V54.95z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#844C9E",
    d: "M144.002,54.95h-23.707l11.85-29.136L144.002,54.95z M134.686,48.006l-2.541-6.228l-2.635,6.228H134.686z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0D76BD",
    points: "159.902,34.275 152.947,34.275 152.947,54.95 146,54.95 146,34.275 139.732,34.275 139.732,27.342  159.902,27.342  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0D76BD",
    points: "178.018,54.95 161.674,54.95 161.674,27.342 168.621,27.342 168.621,48.004 178.018,48.004  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -664.675,
    y: -103.661,
    width: 1526.955,
    height: 792
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M23.136,8.703c0,0,18.374-16.342,37.171,15.271 c0,0,19.184,43.926-9.733,55.694c0,0,20.405-17.167,2.57-52.167C53.144,27.5,44.222,6.681,23.136,8.703"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M11.397,54.121c0,0-22.453-23.244,10.656-34.323 c0,0,35.549-10.82,57.99,21.756c0,0-34.058-29.184-65.687-8.235C14.356,33.319,5.438,40.062,11.397,54.121"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M14.632,46.006c0,0,21.885,21.493,51.621,14.727 c0,0,26.084-5.942,18.249-27.561c0,0,19.322,21.076-10.004,33.105C74.498,66.277,35.447,78.021,14.632,46.006"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M48.612,47.771l5.062,0.609c-0.802,2.954-2.281,5.253-4.442,6.863 c-2.164,1.646-4.928,2.469-8.279,2.469c-4.238,0-7.589-1.304-10.068-3.913c-2.463-2.593-3.704-6.25-3.704-10.956 c0-4.846,1.246-8.627,3.743-11.309c2.509-2.68,5.765-4.028,9.754-4.028c3.868,0,7.019,1.308,9.465,3.939 c2.466,2.624,3.673,6.309,3.673,11.078c0,0.289,0,0.726-0.016,1.302H32.243c0.181,3.168,1.086,5.614,2.695,7.295 c1.622,1.694,3.627,2.534,6.042,2.534c1.806,0,3.324-0.47,4.609-1.401C46.865,51.328,47.866,49.827,48.612,47.771 M32.545,39.778 h16.11c-0.215-2.411-0.832-4.219-1.85-5.413c-1.552-1.873-3.571-2.797-6.054-2.797c-2.242,0-4.127,0.739-5.662,2.225 C33.545,35.289,32.695,37.279,32.545,39.778"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M34.36,4.479c-7.136,0-11.884,4.222-11.884,4.222c21.078-2.022,30,18.798,30,18.798 c17.826,35-2.571,52.167-2.571,52.167c28.917-11.768,9.738-55.691,9.738-55.691C50.404,8.433,41.269,4.479,34.365,4.479 C34.363,4.479,34.362,4.479,34.36,4.479"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -667.9229,
    y1: 478.4512,
    x2: -666.9229,
    y2: 478.4512,
    gradientTransform: "matrix(43.3991 0 0 43.3991 29009.7695 -20722.2773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D76BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#0D76BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2878,
    style: {
      stopColor: "#0E78BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4511,
    style: {
      stopColor: "#0E7CC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    style: {
      stopColor: "#0E84C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7008,
    style: {
      stopColor: "#0D90CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8068,
    style: {
      stopColor: "#0D9FDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9038,
    style: {
      stopColor: "#13B2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    style: {
      stopColor: "#16B9ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B9ED"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.476,
    y: 4.479,
    clipPath: "url(#SVGID_4_)",
    fill: "url(#SVGID_5_)",
    width: 56.346,
    height: 75.187
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_6_",
    x: -664.675,
    y: -103.661,
    width: 1526.955,
    height: 792
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_7_)",
    fill: "#0D76BD",
    d: "M10.708,54.121c0,0-22.419-23.244,10.686-34.323 c0,0,35.536-10.82,57.972,21.756c0,0-34.057-29.184-65.687-8.235C13.679,33.319,4.766,40.062,10.708,54.121"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_7_)",
    fill: "#884C9E",
    d: "M13.955,46.006c0,0,21.889,21.493,51.625,14.727 c0,0,26.08-5.942,18.245-27.561c0,0,19.317,21.076-10.009,33.105C73.816,66.277,34.766,78.021,13.955,46.006"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M34.413,33.792c1.539-1.485,3.414-2.224,5.665-2.224c2.484,0,4.506,0.922,6.071,2.797 c1.006,1.194,1.621,3.002,1.837,5.411h-16.11C32.037,37.279,32.894,35.288,34.413,33.792 M30.268,31.534 c-2.518,2.683-3.76,6.462-3.76,11.306c0,4.71,1.237,8.364,3.708,10.959c2.479,2.61,5.836,3.915,10.065,3.915 c3.359,0,6.115-0.824,8.275-2.471c2.165-1.61,3.643-3.909,4.433-6.862l-5.054-0.612c-0.742,2.057-1.75,3.559-3.019,4.486 c-1.276,0.929-2.798,1.399-4.609,1.399c-2.411,0-4.428-0.84-6.038-2.534c-1.616-1.681-2.509-4.127-2.694-7.295h21.552 c0.022-0.575,0.038-1.014,0.038-1.304c0-4.768-1.237-8.45-3.677-11.076c-2.449-2.633-5.607-3.939-9.483-3.939 C36.016,27.506,32.765,28.852,30.268,31.534"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -675.1113,
    y1: 473.6113,
    x2: -674.1113,
    y2: 473.6113,
    gradientTransform: "matrix(0 -30.2087 30.2087 0 -14267.3135 -20336.5645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D76BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#0D76BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2878,
    style: {
      stopColor: "#0E78BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4511,
    style: {
      stopColor: "#0E7CC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    style: {
      stopColor: "#0E84C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7008,
    style: {
      stopColor: "#0D90CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8068,
    style: {
      stopColor: "#0D9FDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9038,
    style: {
      stopColor: "#13B2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    style: {
      stopColor: "#16B9ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B9ED"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.508,
    y: 27.506,
    clipPath: "url(#SVGID_9_)",
    fill: "url(#SVGID_10_)",
    width: 26.657,
    height: 30.208
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -664.675,
    y: -103.661,
    width: 1526.955,
    height: 792
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_12_)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#171717",
    points: "101.67,65.448 98.672,65.448 98.672,68.227 102.012,68.227 102.012,69.062 97.678,69.062  97.678,61.354 101.842,61.354 101.842,62.188 98.672,62.188 98.672,64.624 101.67,64.624  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M104.449,61.937v1.59h1.441v0.766h-1.441v2.985c0,0.686,0.195,1.075,0.756,1.075 c0.264,0,0.457-0.034,0.584-0.068l0.045,0.755c-0.195,0.079-0.504,0.136-0.893,0.136c-0.469,0-0.846-0.148-1.088-0.423 c-0.285-0.297-0.387-0.789-0.387-1.441v-3.019h-0.859v-0.766h0.859V62.2L104.449,61.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M107.023,60.941h1.008v3.454h0.021c0.16-0.286,0.412-0.537,0.721-0.709 c0.299-0.171,0.652-0.286,1.029-0.286c0.744,0,1.934,0.458,1.934,2.368v3.293h-1.008v-3.179c0-0.892-0.332-1.647-1.279-1.647 c-0.652,0-1.166,0.457-1.352,1.006c-0.055,0.137-0.066,0.286-0.066,0.481v3.339h-1.008V60.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M114.494,61.971c0.01,0.343-0.24,0.617-0.641,0.617c-0.355,0-0.607-0.274-0.607-0.617 c0-0.355,0.264-0.63,0.629-0.63C114.254,61.341,114.494,61.616,114.494,61.971 M113.373,63.526h1.006v5.535h-1.006V63.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M119.996,68.856c-0.264,0.137-0.848,0.32-1.59,0.32c-1.67,0-2.758-1.132-2.758-2.825 c0-1.704,1.168-2.939,2.975-2.939c0.596,0,1.121,0.149,1.395,0.286l-0.229,0.778c-0.238-0.138-0.617-0.263-1.166-0.263 c-1.27,0-1.955,0.937-1.955,2.093c0,1.28,0.822,2.07,1.922,2.07c0.57,0,0.947-0.149,1.234-0.275L119.996,68.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M121.037,68.033c0.299,0.194,0.824,0.4,1.326,0.4c0.734,0,1.076-0.366,1.076-0.823 c0-0.481-0.285-0.744-1.029-1.018c-0.996-0.355-1.465-0.904-1.465-1.567c0-0.892,0.723-1.624,1.91-1.624 c0.563,0,1.053,0.16,1.363,0.343l-0.252,0.732c-0.219-0.137-0.617-0.32-1.133-0.32c-0.596,0-0.928,0.343-0.928,0.754 c0,0.458,0.332,0.664,1.053,0.938c0.961,0.366,1.453,0.847,1.453,1.67c0,0.972-0.756,1.658-2.07,1.658 c-0.607,0-1.166-0.148-1.557-0.377L121.037,68.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M129.412,66.637l-0.801,2.424h-1.029l2.619-7.708h1.201l2.631,7.708h-1.064l-0.824-2.424H129.412z  M131.939,65.859l-0.756-2.219c-0.172-0.503-0.285-0.96-0.398-1.406h-0.023c-0.115,0.457-0.242,0.926-0.389,1.395l-0.756,2.23 H131.939z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M139.775,60.941v6.691c0,0.492,0.012,1.052,0.047,1.429h-0.904l-0.045-0.96h-0.023 c-0.311,0.617-0.984,1.086-1.889,1.086c-1.338,0-2.367-1.132-2.367-2.813c-0.012-1.842,1.133-2.974,2.482-2.974 c0.846,0,1.418,0.4,1.67,0.847h0.023v-3.306H139.775z M138.77,65.779c0-0.125-0.012-0.297-0.047-0.423 c-0.148-0.64-0.697-1.166-1.451-1.166c-1.041,0-1.658,0.914-1.658,2.138c0,1.121,0.549,2.047,1.635,2.047 c0.674,0,1.291-0.446,1.475-1.2c0.035-0.138,0.047-0.275,0.047-0.435V65.779z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M141.836,63.526l1.086,3.111c0.184,0.503,0.332,0.96,0.445,1.418h0.035 c0.125-0.458,0.287-0.915,0.469-1.418l1.074-3.111h1.053l-2.174,5.535h-0.959l-2.104-5.535H141.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M149.969,69.062l-0.08-0.698h-0.035c-0.307,0.435-0.902,0.824-1.691,0.824 c-1.121,0-1.693-0.789-1.693-1.59c0-1.338,1.189-2.07,3.328-2.059v-0.114c0-0.458-0.125-1.281-1.258-1.281 c-0.516,0-1.051,0.16-1.441,0.412l-0.229-0.664c0.459-0.297,1.121-0.491,1.818-0.491c1.693,0,2.105,1.155,2.105,2.264v2.07 c0,0.481,0.021,0.95,0.09,1.327H149.969z M149.82,66.237c-1.098-0.023-2.346,0.172-2.346,1.247c0,0.651,0.436,0.96,0.949,0.96 c0.721,0,1.18-0.457,1.34-0.926c0.033-0.103,0.057-0.217,0.057-0.32V66.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M152.418,65.024c0-0.572-0.012-1.041-0.047-1.498h0.895l0.055,0.915h0.025 c0.273-0.526,0.914-1.041,1.83-1.041c0.764,0,1.955,0.457,1.955,2.356v3.305h-1.008v-3.19c0-0.892-0.332-1.636-1.279-1.636 c-0.664,0-1.18,0.469-1.352,1.029c-0.045,0.126-0.066,0.298-0.066,0.469v3.328h-1.008V65.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M162.713,68.856c-0.264,0.137-0.848,0.32-1.59,0.32c-1.67,0-2.756-1.132-2.756-2.825 c0-1.704,1.166-2.939,2.975-2.939c0.594,0,1.119,0.149,1.395,0.286l-0.23,0.778c-0.238-0.138-0.615-0.263-1.164-0.263 c-1.271,0-1.957,0.937-1.957,2.093c0,1.28,0.824,2.07,1.922,2.07c0.57,0,0.949-0.149,1.234-0.275L162.713,68.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M164.385,66.477c0.021,1.361,0.891,1.922,1.898,1.922c0.721,0,1.154-0.126,1.531-0.286l0.172,0.72 c-0.354,0.16-0.961,0.343-1.84,0.343c-1.705,0-2.723-1.121-2.723-2.79c0-1.67,0.982-2.985,2.596-2.985 c1.807,0,2.289,1.589,2.289,2.607c0,0.206-0.025,0.366-0.037,0.469H164.385z M167.336,65.757 c0.012-0.641-0.264-1.636-1.396-1.636c-1.018,0-1.463,0.938-1.543,1.636H167.336z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#171717",
    points: "173.01,62.2 170.664,62.2 170.664,61.354 176.371,61.354 176.371,62.2 174.018,62.2  174.018,69.062 173.01,69.062  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M176.947,66.477c0.021,1.361,0.891,1.922,1.896,1.922c0.721,0,1.156-0.126,1.533-0.286l0.172,0.72 c-0.354,0.16-0.961,0.343-1.842,0.343c-1.705,0-2.721-1.121-2.721-2.79c0-1.67,0.982-2.985,2.596-2.985 c1.807,0,2.287,1.589,2.287,2.607c0,0.206-0.023,0.366-0.035,0.469H176.947z M179.896,65.757 c0.012-0.641-0.264-1.636-1.396-1.636c-1.016,0-1.463,0.938-1.543,1.636H179.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M186.063,68.856c-0.264,0.137-0.848,0.32-1.59,0.32c-1.67,0-2.756-1.132-2.756-2.825 c0-1.704,1.166-2.939,2.975-2.939c0.594,0,1.121,0.149,1.393,0.286l-0.227,0.778c-0.24-0.138-0.617-0.263-1.166-0.263 c-1.271,0-1.957,0.937-1.957,2.093c0,1.28,0.822,2.07,1.922,2.07c0.572,0,0.949-0.149,1.234-0.275L186.063,68.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M187.242,60.941h1.006v3.454h0.023c0.16-0.286,0.412-0.537,0.719-0.709 c0.299-0.171,0.652-0.286,1.029-0.286c0.744,0,1.936,0.458,1.936,2.368v3.293h-1.008v-3.179c0-0.892-0.332-1.647-1.281-1.647 c-0.652,0-1.166,0.457-1.35,1.006c-0.057,0.137-0.068,0.286-0.068,0.481v3.339h-1.006V60.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M193.592,65.024c0-0.572-0.012-1.041-0.047-1.498h0.893l0.057,0.915h0.023 c0.273-0.526,0.916-1.041,1.83-1.041c0.766,0,1.955,0.457,1.955,2.356v3.305h-1.006v-3.19c0-0.892-0.332-1.636-1.281-1.636 c-0.662,0-1.178,0.469-1.35,1.029c-0.047,0.126-0.068,0.298-0.068,0.469v3.328h-1.006V65.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M204.949,66.248c0,2.048-1.418,2.94-2.756,2.94c-1.498,0-2.654-1.098-2.654-2.848 c0-1.853,1.213-2.939,2.746-2.939C203.873,63.401,204.949,64.556,204.949,66.248 M200.559,66.306 c0,1.212,0.695,2.127,1.682,2.127c0.959,0,1.68-0.903,1.68-2.15c0-0.938-0.469-2.127-1.658-2.127S200.559,65.254,200.559,66.306"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.221,
    y: 60.941,
    fill: "#171717",
    width: 1.008,
    height: 8.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M213.93,66.248c0,2.048-1.418,2.94-2.756,2.94c-1.498,0-2.654-1.098-2.654-2.848 c0-1.853,1.213-2.939,2.746-2.939C212.854,63.401,213.93,64.556,213.93,66.248 M209.537,66.306c0,1.212,0.697,2.127,1.684,2.127 c0.959,0,1.68-0.903,1.68-2.15c0-0.938-0.469-2.127-1.658-2.127S209.537,65.254,209.537,66.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M219.971,63.526c-0.023,0.401-0.047,0.847-0.047,1.521v3.214c0,1.27-0.252,2.048-0.789,2.528 c-0.537,0.503-1.314,0.663-2.012,0.663c-0.664,0-1.395-0.16-1.842-0.457l0.252-0.766c0.365,0.228,0.938,0.434,1.625,0.434 c1.029,0,1.783-0.537,1.783-1.933v-0.617h-0.023c-0.309,0.514-0.904,0.926-1.76,0.926c-1.375,0-2.357-1.166-2.357-2.699 c0-1.876,1.225-2.94,2.492-2.94c0.961,0,1.488,0.504,1.729,0.961h0.021l0.047-0.835H219.971z M218.93,65.711 c0-0.172-0.012-0.32-0.059-0.458c-0.182-0.583-0.674-1.063-1.406-1.063c-0.961,0-1.645,0.812-1.645,2.093 c0,1.086,0.547,1.99,1.633,1.99c0.619,0,1.18-0.389,1.396-1.03c0.059-0.171,0.08-0.366,0.08-0.537V65.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M221.963,63.526l1.213,3.271c0.125,0.366,0.262,0.8,0.354,1.132h0.023 c0.102-0.332,0.217-0.755,0.354-1.155l1.098-3.248h1.064l-1.51,3.946c-0.721,1.898-1.213,2.87-1.898,3.465 c-0.492,0.435-0.982,0.606-1.234,0.652l-0.252-0.847c0.252-0.079,0.582-0.239,0.881-0.491c0.273-0.218,0.617-0.606,0.846-1.121 c0.045-0.103,0.08-0.183,0.08-0.24c0-0.057-0.023-0.137-0.07-0.263l-2.047-5.101H221.963z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#171717",
    points: "229.445,61.354 230.439,61.354 230.439,68.228 233.732,68.228 233.732,69.062 229.445,69.062  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M235.975,61.937v1.59h1.441v0.766h-1.441v2.985c0,0.686,0.195,1.075,0.756,1.075 c0.264,0,0.457-0.034,0.584-0.068l0.045,0.755c-0.195,0.079-0.502,0.136-0.893,0.136c-0.469,0-0.846-0.148-1.086-0.423 c-0.287-0.297-0.389-0.789-0.389-1.441v-3.019h-0.857v-0.766h0.857V62.2L235.975,61.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M243.262,60.941v6.691c0,0.492,0.014,1.052,0.047,1.429h-0.904l-0.045-0.96h-0.023 c-0.309,0.617-0.982,1.086-1.887,1.086c-1.34,0-2.369-1.132-2.369-2.813c-0.01-1.842,1.133-2.974,2.484-2.974 c0.844,0,1.418,0.4,1.67,0.847h0.021v-3.306H243.262z M242.256,65.779c0-0.125-0.012-0.297-0.047-0.423 c-0.146-0.64-0.695-1.166-1.451-1.166c-1.041,0-1.658,0.914-1.658,2.138c0,1.121,0.549,2.047,1.635,2.047 c0.674,0,1.293-0.446,1.475-1.2c0.035-0.138,0.047-0.275,0.047-0.435V65.779z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M244.58,68.467c0-0.423,0.285-0.72,0.686-0.72s0.674,0.297,0.674,0.72c0,0.412-0.262,0.721-0.686,0.721 C244.854,69.188,244.58,68.879,244.58,68.467"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainlogo);
export default __webpack_public_path__ + "static/media/mainlogo.6f9a53ae8a9b5b8e3d6df631fcfcc824.svg";
export { ForwardRef as ReactComponent };